import * as React from 'react';
import { Router } from 'react-router';
import { CookiesProvider } from 'react-cookie';

import { AppView } from 'view/AppView/AppView';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'component/SnackbarProvider/SnackbarProvider';
import history from 'app/history';
import { theme } from 'app/theme/theme';
import { useInitializeGTM } from 'shared/hooks/useInitializeGTM';
import { WBGrowthBookProvider } from 'component/WBGrowthBookProvider/WBGrowthBookProvider';
import { useWBDevelopmentInProductionIndicator } from '@workbuzz/shared-ui';
import { getAppConfig } from 'app/getConfig';

export const App = () => {
  useInitializeGTM();
  useWBDevelopmentInProductionIndicator(getAppConfig().NODE_ENV === 'development');

  return (
    <CookiesProvider>
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider>
            <WBGrowthBookProvider>
              <AppView />
            </WBGrowthBookProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </Router>
    </CookiesProvider>
  );
};
